const BuildingWhiteIcon = () => (
  <div>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4997 22.0001H4.07973C2.91973 22.0001 1.96973 21.0701 1.96973 19.9301V5.09011C1.96973 2.47011 3.91973 1.2801 6.30973 2.4501L10.7497 4.63011C11.7097 5.10011 12.4997 6.3501 12.4997 7.4101V22.0001Z"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.97 15.0601V18.8401C21.97 21.0001 20.97 22.0001 18.81 22.0001H12.5V10.4201L12.97 10.5201L17.47 11.5301L19.5 11.9801C20.82 12.2701 21.9 12.9501 21.96 14.8701C21.97 14.9301 21.97 14.9901 21.97 15.0601Z"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 9.00012H8.97"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 13.0001H8.97"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4697 11.5301V14.7501C17.4697 15.9901 16.4597 17.0001 15.2197 17.0001C13.9797 17.0001 12.9697 15.9901 12.9697 14.7501V10.5201L17.4697 11.5301Z"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9597 14.8701C21.8997 16.0501 20.9197 17.0001 19.7197 17.0001C18.4797 17.0001 17.4697 15.9901 17.4697 14.7501V11.5301L19.4997 11.9801C20.8197 12.2701 21.8997 12.9501 21.9597 14.8701Z"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default BuildingWhiteIcon;
